import Tabs from "devextreme-react/tabs";
import {useContext, useEffect} from "react";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useTitle} from "../../../../contexts/title";
import {AR, OrderStatus} from "../../../../types/enums";
import {WorkOrderContext} from "../context/WorkOrderContext";
import {WorkOrderProgressStepInfo} from "../types/WorkOrderProgressStepInfo";

export default function WorkOrderProgress() {

	const { order } = useContext(WorkOrderContext);

	const location = useLocation();
	const navigate = useNavigate();
	const [params] = useSearchParams();
	const returnUrl = encodeURIComponent(params.get("returnUrl") ?? "");

	const resolvedIcon = 'dx-icon dx-icon-Inscyth-Checked-Box';
	const unresolvedIcon = '';

	var steps: WorkOrderProgressStepInfo[] =
		[
			{
				text: 'Info',
				navigateTo: '/cfi/work-order/' + order.details.workOrderID,
				visible: true,
				disabled: false,
				icon: 'dx-icon dx-icon-info'
			},
			{
				text: 'Contact',
				navigateTo: '/cfi/work-order/' + order.details.workOrderID + '/410',
				visible: true,
				disabled: order.details.orderStatusID === OrderStatus.Hold,
				icon: order.details.resolvedARs.includes(AR.WOCfiToContactCustomer) ? resolvedIcon : unresolvedIcon
			},
			{
				text: 'Schedule',
				navigateTo: '/cfi/work-order/' + order.details.workOrderID + '/420',
				visible: true,
				disabled: order.details.orderStatusID === OrderStatus.Hold ||
					(!order.details.resolvedARs.includes(AR.WOCfiToScheduleAppointment) &&
						!order.details.activeARs.includes(AR.WOCfiToScheduleAppointment)),
				icon: order.details.resolvedARs.includes(AR.WOCfiToScheduleAppointment) ? resolvedIcon : unresolvedIcon
			},
			{
				text: 'Upload WOC',
				navigateTo: '/cfi/work-order/' + order.details.workOrderID + '/440',
				visible: true,
				disabled: order.details.orderStatusID === OrderStatus.Hold ||
					(!order.details.resolvedARs.includes(AR.WOCfiToUploadWOC) &&
						!order.details.activeARs.includes(AR.WOCfiToUploadWOC) &&
						!order.details.resolvedARs.includes(AR.WOCfoToEnterWorkCompleteDate) &&
						!order.details.activeARs.includes(AR.WOCfoToEnterWorkCompleteDate)),
				icon: order.details.resolvedARs.includes(AR.WOCfiToUploadWOC) ? resolvedIcon : unresolvedIcon
			},
			{
				text: 'Complete',
				navigateTo: '/cfi/work-order/' + order.details.workOrderID + '/430',
				visible: true,
				disabled: order.details.orderStatusID === OrderStatus.Hold ||
					(!order.details.resolvedARs.includes(AR.WOCfoToEnterWorkCompleteDate) &&
						!order.details.activeARs.includes(AR.WOCfoToEnterWorkCompleteDate)),
				icon: order.details.resolvedARs.includes(AR.WOCfoToEnterWorkCompleteDate) ? resolvedIcon : unresolvedIcon
			}
		]

	let selectedStep: WorkOrderProgressStepInfo | undefined;

	steps.forEach(step => {
		if (location.pathname.includes(step.navigateTo) && (!selectedStep || selectedStep.navigateTo < step.navigateTo)) {
			selectedStep = step;
		}
	});

	const pageTitle = useTitle();
	useEffect(() => {
		if (selectedStep) {
			pageTitle.setTitle(selectedStep?.text)
		}
	}, [pageTitle, selectedStep]);

	return (
		<Tabs
			className="order-progress"
			dataSource={steps}
			selectedItem={selectedStep}
			onItemClick={(e) => navigate(e.itemData?.navigateTo! + (!!returnUrl ? '?returnUrl=' + returnUrl : ''))}
		>

		</Tabs>
	);
}
